import { render, staticRenderFns } from "./OpenEndedMasonry.vue?vue&type=template&id=47e3d3dd&scoped=true&"
import script from "./OpenEndedMasonry.vue?vue&type=script&lang=js&"
export * from "./OpenEndedMasonry.vue?vue&type=script&lang=js&"
import style0 from "./OpenEndedMasonry.vue?vue&type=style&index=0&id=47e3d3dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e3d3dd",
  null
  
)

export default component.exports